var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTicket = function SvgTicket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16,4 L16,6.26760632 C15.4021661,6.61342606 15,7.25974756 15,8 C15,8.74025244 15.4021661,9.38657394 16,9.73239368 L16,12 L0,12 L0.000332146429,9.73224343 C0.597950343,9.38638676 1,8.74014524 1,8 C1,7.25985476 0.597950343,6.61361324 0.000332146429,6.26775657 L0,4 L16,4 Z M1.00014648,5 L1.00014648,5.76388971 C1.62531632,6.32298141 2,7.12919799 2,8 C2,8.87080201 1.62531632,9.67701859 1.00014648,10.2361103 L1.00014648,11 L14.999968,11 L14.999968,10.2362912 C14.3747685,9.67719598 14,8.87090054 14,8 C14,7.12909946 14.3747685,6.32280402 14.999968,5.76370882 L14.999968,5 L1.00014648,5 Z M10,5 L11,5 L11,6 L10,6 L10,5 Z M10,7 L11,7 L11,9 L10,9 L10,7 Z M10,10 L11,10 L11,11 L10,11 L10,10 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTicket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ticket.ce9966d1.svg";
export { ForwardRef as ReactComponent };